import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as l, createElementBlock as d, normalizeClass as n, createElementVNode as o } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconChevronLeft",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(r).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, f = ["aria-label", "data-qa", "aria-hidden"];
function m(a, t, i, u, _, e) {
  return l(), d("svg", {
    "aria-label": i.ariaLabel,
    class: n([e.iconSizeClass, "d-icon d-icon--chevron-left"]),
    "data-qa": e.dataQA,
    "aria-hidden": e.ariaHidden,
    role: "img",
    "data-name": "Chevron Left",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [...t[0] || (t[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7.854 2.646a.5.5 0 0 1 0 .708L5.207 6l2.647 2.646a.5.5 0 1 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 0 1 .708 0Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])], 10, f);
}
const b = /* @__PURE__ */ s(c, [["render", m]]);
export {
  b as default
};
//# sourceMappingURL=chevron-left.js.map
